import { css } from "@emotion/react";

export const styCountdown = css`
  width: 75%%;
  margin: auto;
  max-width: 320px;

  > div {
    display: flex;
    justify-content: space-between;

    > p {
      margin: 0;
      flex-basis: 30%;

      :not(:first-of-type) {
        border-left: 1px solid #f9f9f9;
      }
    }
  }
`;

export const styTime = css`
  font-size: 20px;
  font-weight: 700;
`;
